/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authExternalCallbackGet$Json } from '../fn/external-auth/auth-external-callback-get-json';
import { AuthExternalCallbackGet$Json$Params } from '../fn/external-auth/auth-external-callback-get-json';
import { authExternalCallbackGet$Plain } from '../fn/external-auth/auth-external-callback-get-plain';
import { AuthExternalCallbackGet$Plain$Params } from '../fn/external-auth/auth-external-callback-get-plain';
import { authExternalLoginGet } from '../fn/external-auth/auth-external-login-get';
import { AuthExternalLoginGet$Params } from '../fn/external-auth/auth-external-login-get';
import { AuthResponseDto } from '../models/auth-response-dto';

@Injectable({ providedIn: 'root' })
export class ExternalAuthApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authExternalLoginGet()` */
  static readonly AuthExternalLoginGetPath = '/auth/external/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authExternalLoginGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalLoginGet$Response(params?: AuthExternalLoginGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = authExternalLoginGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authExternalLoginGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalLoginGet(params?: AuthExternalLoginGet$Params, context?: HttpContext): Observable<void> {
    const resp = this.authExternalLoginGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authExternalCallbackGet()` */
  static readonly AuthExternalCallbackGetPath = '/auth/external/callback';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authExternalCallbackGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalCallbackGet$Plain$Response(params?: AuthExternalCallbackGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authExternalCallbackGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authExternalCallbackGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalCallbackGet$Plain(params?: AuthExternalCallbackGet$Plain$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authExternalCallbackGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authExternalCallbackGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalCallbackGet$Json$Response(params?: AuthExternalCallbackGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authExternalCallbackGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authExternalCallbackGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalCallbackGet$Json(params?: AuthExternalCallbackGet$Json$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authExternalCallbackGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

}
